import { render, staticRenderFns } from "./SensorTrigger.vue?vue&type=template&id=06e0309d&scoped=true"
import script from "./SensorTrigger.vue?vue&type=script&lang=js"
export * from "./SensorTrigger.vue?vue&type=script&lang=js"
import style0 from "./SensorTrigger.vue?vue&type=style&index=0&id=06e0309d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e0309d",
  null
  
)

export default component.exports